import styled from "styled-components";

export const AuthPageContainer = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 48px;
    width: 100%;

    @media (max-width: 768px) {
        padding: 24px;
    }
`
export const Content = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 32px 0;
    width: 100%;

    .auth-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }
`
export const ToggleContainer = styled.div`
    display: flex;
    gap: 28px;
    justify-content: center;
    padding-bottom: 24px;
`
export const MainGradientBGContainer = styled.div`
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: -500;
`

// Email verification styles
export const VerifyEmailContent = styled.div`
    backdrop-filter: blur(0px);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    max-width: 640px;
    width: 100%;
    text-align: center;
`;

export const VerifyEmailButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const VerifyEmailError = styled.div`
    background: linear-gradient(135deg, #b02a37, #9a242f);
    border: 1px solid rgba(176, 42, 55, 0.6);
    color: #FFFFFF;
    padding: 12px;
    border-radius: 6px;
    font-size: 14px;

    h3 {
        color: #FFFFFF;
    }
`;

export const VerifyEmailSuccess = styled.div`
    background: #efe;
    padding: 12px;
    border-radius: 6px;
    font-size: 14px;
    border: 1px solid #cfc;

    h3 {
        color: green;
    };
`;